import { Box, Stack, Typography } from "@mui/material"
import { formatCurrency } from "../../../utils/formatters"
import { useData } from "../../../utils/useData";
import { ModuleFeeTooltip } from "../Standard/Tooltips/ModuleFeeTooltip";

export const AllowanceCheckoutProductDetails = ({ monthlyUserFee }: { monthlyUserFee: number }) => {

    return (
        <Box>
            <Typography variant="h6" paddingBottom={2}>Module Information</Typography>
            <Typography textAlign={"justify"}> Upfront controls, real-time monitoring, and easy access to funds — no more out-of-pocket payments or waiting for reimbursements. Boost employee engagement with a modern solution that meets evolving needs. Extraordinary gives your people instant access to the funds they need, reducing stress and eliminating concerns around affordability and reimbursement delays.</Typography>

            <Stack direction={"row"} sx={{marginTop: 8, marginBottom: 1}} alignItems={"center"} alignContent={"center"}>
                <Typography variant="h6" textAlign={"justify"}>Module Fee</Typography>
                <ModuleFeeTooltip />
            </Stack>
            <Typography textAlign={"justify"}>{formatCurrency(monthlyUserFee)}/month per user</Typography>
        </Box>
    )
}